import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0d1cd308"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-card-cover"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "course-card-info"
};
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = ["title"];
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "teacher"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = {
  class: "name ml"
};
const _hoisted_10 = {
  class: "time"
};
import { formatDate } from '@/plugins/utils';
import { handleLogin } from '@/plugins/utils';
export default {
  props: {
    info: {
      type: Object
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    showResultTag: Boolean,
    resultMap: Object
  },

  setup(__props) {
    const props = __props;

    const goDetail = () => {
      if (unref(props.authType) == 2 && !unref(props.userInfo)) {
        handleLogin();
      } else {
        props.info.course_url && window.open(unref(props.info.course_url));
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        onClick: goDetail,
        class: "course-card"
      }, [__props.showResultTag && __props.info.results_id && __props.info.results_name ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "tag-btn",
        style: _normalizeStyle({
          background: __props.resultMap[__props.info.results_id]
        })
      }, _toDisplayString(__props.info.results_name), 5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: __props.info.course_cover_url || require('@/assets/images/common/course_cover.png')
      }, null, 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "course-name text-overflow",
        title: __props.info.course_name.length > 15 ? __props.info.course_name : ''
      }, _toDisplayString(__props.info.course_name), 9, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "name texts",
        title: __props.info.lecturer.length > 10 ? __props.info.lecturer : ''
      }, _toDisplayString(__props.info.lecturer), 9, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(__props.info.organ_name), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(__props.info.students_num) + "人参加", 1)])])])]);
    };
  }

};